import React from "react";
import {Button} from "@mui/material";

import Container from 'react-bootstrap/Container';

import {useArticlesCount, useArticlesParams} from "../../../../api/blog";
import {INITIAL_DATA_REQUEST} from "../../../../constants";
import {COLORS} from "../../../../config/constants";

import styles from './Pagination.module.scss';

type PaginationBlogProps = {
    onUpdate?: (params: {page: number}) => void;
};

function PaginationBlog({onUpdate}: PaginationBlogProps) {

    const [ page, setPage ] = React.useState(0);

    const articlesParams = useArticlesParams();

    const articlesCount = useArticlesCount();

    const totalPages = Math.ceil(articlesCount / (articlesParams.pageSize || INITIAL_DATA_REQUEST.pageSize));

    const sendRequest = (data: {page: number}) => {
        onUpdate && onUpdate({
            page: page + 1,
            ...data
        })
    }

    const handleChangePage = (
        newPage: number,
    ) => {
        setPage(newPage);
        sendRequest({
            page: newPage + 1
        });
    };

    const getPaginationNumbers = () => {

        const numbers = [];

        const arrowBack = <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.794 5.838C2.814 4.69 1.778 3.85 0.714 3.304V2.912C1.778 2.366 2.814 1.526 3.794 0.378H4.592C4.144 1.358 3.696 2.114 3.248 2.604H21.098V3.598H3.248C3.682 4.088 4.144 4.844 4.592 5.838H3.794Z" fill="currentColor"/>
        </svg>;

        const arrowForward = <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.018 5.838H17.22C17.668 4.844 18.13 4.088 18.564 3.598H0.714V2.604H18.564C18.116 2.114 17.668 1.358 17.22 0.378H18.018C18.998 1.526 20.034 2.366 21.098 2.912V3.304C20.034 3.85 18.998 4.69 18.018 5.838Z" fill="currentColor"/>
        </svg>;

        numbers.push(arrowBack);

        for (let i = 1; i <= totalPages; i++) {
            numbers.push(i);
        }

        numbers.push(arrowForward);

        return numbers;
    }

    const paginationNumbers = getPaginationNumbers();

    const checkButtonShouldBeDisabled = (index: number) => {

        if (index === 0 && articlesParams.page === 1) {
            return true;
        }

        if (index === articlesParams.page) {
            return true;
        }

        return index === totalPages + 1 && articlesParams.page === totalPages;

    }

    const onChange = (index: number) => {

        let indexToNextPage = 0;

        if (index === 0) {
            indexToNextPage = articlesParams.page - 2;
        }

        else if (index === totalPages + 1) {
            indexToNextPage = articlesParams.page;
        }

        else if (index !== 0) {
            indexToNextPage = index - 1;
        }

        handleChangePage(indexToNextPage);
    }

    return (
        <div className={styles.pagination}>
            <Container className={styles.paginationContainer}>
                {paginationNumbers.map((item, index) => (
                    <Button variant="outlined" key={index} sx={{
                        '&.MuiButton-outlined': {
                            border: `1px solid ${COLORS.PRIMARY_LIGHT}`,
                            color: COLORS.PRIMARY,
                            height: '36px',
                            width: '40px',
                            minWidth: '40px',
                            marginRight: '16px',
                            '@media (max-width: 767px)': {
                                height: '30px',
                                width: '28px',
                                minWidth: '28px',
                                marginRight: '8px',
                            },
                            'img': {
                                marginRight: '0',
                            },
                            '&:first-child, &:last-child': {
                                width: '54px',
                                minWidth: '54px',
                                '@media (max-width: 767px)': {
                                    width: '41px',
                                    minWidth: '41px',
                                },
                            },
                            '&.Mui-disabled': {
                                border: `1px solid ${COLORS.GRAY_BORDER}`,
                                color: COLORS.GRAY_BORDER,
                            },

                        }
                    }}
                            disabled={checkButtonShouldBeDisabled(index)}
                            onClick={() => onChange(index)}
                    >
                        {item}
                    </Button>
                ))}
            </Container>
        </div>
    );
}

export default PaginationBlog;
